'use strict';

/**
 * @puffin-core/env — the ecosystem's runtime-environment classifiers. Zero dependencies.
 *
 * - `./nodeEnv` — the canonical NODE_ENV classifier (HARD-JWTS-001 / A-3): the local-dev allow-list and the deployed
 *   public environments.
 * - `./sideInstance` — the SIDE INSTANCE classifier (OWNER-RULINGS-WALK-BUILDS SIDE-INSTANCE): a local API declared to
 *   run beside the Dev Conductor's on a side port, with no background work.
 *
 * @module @puffin-core/env
 */

module.exports = {
  ...require('./nodeEnv'),
  ...require('./sideInstance'),
};
